import { BaseComponent } from '@pixelart/component-handler';
import Plyr from 'plyr';

export class Video extends BaseComponent {
    protected VIDEO_SELECTOR: string = '.video__video';
    private static VIDEO_PLAY_CLASS = 'video--playing';
    private static VIDEO_STARTED_CLASS = 'video--started';

    private videoElement: JQuery;
    private player: any;

    constructor(element: Element) {
        super(element);
    }

    public init() {
        this.videoElement = this.$element.find(this.VIDEO_SELECTOR);

        this.initPlayer();
    }

    // destroy
    public destroy() {
        // destroy
    }

    private initPlayer() {
        if (this.videoElement) {
            this.player = new Plyr(this.videoElement[0], {
                controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'captions',
                    'fullscreen',
                ],
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/video/video.class.ts